<template>
  <div class="main-menu">
    <Background :src="backgroundImg"></Background>
    <div class="content">
      <button
        type="button"
        class="new-arrivals-button"
        @click="navigateTo('new-arrivals')"
      >
        {{ newArrivalsText }}
        <small v-if="newArrivalsDate" class="rotation-date">{{ newArrivalsDate }}</small>
      </button>
      <div
        v-if="isDisableQuizz"
        class="center-image disable-quizz-center-image-bg"
      >
        <div class="text" :class="{ 'right-align': selectedLanguage == 'ar' }">
          <h1>
            {{ this.replaceText(centerImage.title) }}
          </h1>
        </div>
      </div>
      <div v-if="!isDisableQuizz" class="center-image">
        <div class="text" :class="{ 'right-align': selectedLanguage == 'ar' }">
          <div class="small animated fadeInUp delay7s">
            {{ this.replaceText(centerImage.title) }}
          </div>
          <div class="large animated fadeInUp delay7_25s">
            {{ centerImage.content }}
          </div>
          <div v-if="showContent2" class="medium animated fadeInUp delay7_25s">
            {{ centerImage.content2 }}
          </div>
        </div>
        <div class="center-image-middle">
          <div class="animation-group">
            <img
              src="/images/main-menu/quiz_poster_before.png"
              class="animated zoomIn delay7_25s"
              alt=""
            />
            <img
              src="/images/main-menu/quiz_poster_after.png"
              class="animated zoomIn delay7s"
              alt=""
            />
          </div>
        </div>
        <div class="start-btn-container" v-if="isDisableQuizz === false">
          <a
            :href="quizLink"
            id="start-btn"
            :class="{ disabled: isDisableQuizz === true }"
          >
            <span class="btn-elements">
              <span class="btn-text">{{ centerImage.startquiz }}</span>
              <span class="animation-group">
                <img
                  src="/images/main-menu/start_arrow.png"
                  alt="start"
                  class="arrow-mover"
                />
                <img
                  src="/images/main-menu/start_arrow_bg.png"
                  alt="start-mover"
                />
              </span>
            </span>
          </a>
        </div>
        <div
          class="start-btn-container"
          v-if="hasPlayNowLink()"
        >
          <a
            :href="playNowLink"
            id="start-btn"
            :class="{ disabled: isDisableQuizz === true }"
          >
            <span class="btn-elements">
              <span class="btn-text">Play Now</span>
              <span class="animation-group">
                <img
                  src="/images/main-menu/start_arrow.png"
                  alt="start"
                  class="arrow-mover"
                />
                <img
                  src="/images/main-menu/start_arrow_bg.png"
                  alt="start-mover"
                />
              </span>
            </span>
          </a>
        </div>
        <div class="start-btn-container" v-if="hasPlayAndWinLink()">
          <a
            :href="playAndWinLink"
            id="start-btn"
            :class="{ disabled: isDisableQuizz === true }"
          >
            <span class="btn-elements">
              <span class="btn-text">Play and Win</span>
              <span class="animation-group">
                <img
                  src="/images/main-menu/start_arrow.png"
                  alt="start"
                  class="arrow-mover"
                />
                <img
                  src="/images/main-menu/start_arrow_bg.png"
                  alt="start-mover"
                />
              </span>
            </span>
          </a>
        </div>
        <div class="start-btn-container" v-if="hasWorldCupQuizLink()">
          <a
            :href="worldCupQuizLink"
            id="start-btn"
            :class="{ disabled: isDisableQuizz === true }"
          >
            <span class="btn-elements">
              <span class="btn-text">World Cup Quiz</span>
              <span class="animation-group">
                <img
                  src="/images/main-menu/start_arrow.png"
                  alt="start"
                  class="arrow-mover"
                />
                <img
                  src="/images/main-menu/start_arrow_bg.png"
                  alt="start-mover"
                />
              </span>
            </span>
          </a>
        </div>
      </div>
      <div
        v-if="Object.keys(buttons).length !== 0"
        class="menuButton_conatiner1"
        :class="{ 'menu-button-right': selectedLanguage == 'ar' }"
      >
        <MainMenuButton
          id="kingdom-of-living-things"
          :title="buttons.kingdomOfLivingThings"
          icon-height=""
          icon-width="70px"
          icon-left-position=""
          @click="navigateTo('kingdom-of-living-things')"
        ></MainMenuButton>
        <MainMenuButton
          id="human-body"
          :title="buttons.humanBody"
          icon-height=""
          icon-width="120px"
          icon-position="25px"
          @click="navigateTo('human-body')"
        ></MainMenuButton>
        <MainMenuButton
          id="space-science"
          :title="buttons.spaceScience"
          icon-height=""
          icon-width="120px"
          icon-position="10px"
          @click="navigateTo('space-science')"
        ></MainMenuButton>
      </div>
      <div
        class="menuButton_container2"
        :class="{ 'menu-button-left': selectedLanguage == 'ar' }"
      >
        <MainMenuButton
          id="art"
          :title="buttons.art"
          icon-height=""
          icon-width="70px"
          icon-position="-5px"
          @click="navigateTo('art')"
        ></MainMenuButton>
        <MainMenuButton
          icon-height=""
          icon-width="120px"
          icon-left-position=""
          id="cultural-heritage-history"
          :title="buttons.culturalHeritageHistory"
          @click="navigateTo('cultural-heritage-history')"
        ></MainMenuButton>
        <MainMenuButton
          id="archaeology"
          :title="buttons.archaeology"
          icon-height=""
          icon-width="90px"
          icon-left-position=""
          @click="navigateTo('archaeology')"
        ></MainMenuButton>
        <div
          v-if="showFootballContent"
          class="football-content-button"
          @click="navigateTo('football/football-videos')"
        >
          <p>Football</p>
        </div>
        <div
          v-if="showWorldCupContent"
          class="worldcup-content-button"
          @click="openStrikerLive()"
        >
          <p>World Cup Live Score</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewArrivalsDate } from "../../utils/new-arrivals";
import { getSelectedLanguage } from "../../aframe/utils/local-storage.utils";
import { getDomainConfigValue } from "../../utils/domain-config";
import {
    getPlayAndWinLink,
    getPlayNowLink,
    getQuizLink,
    getWorldCupQuizLink,
    hasPlayAndWinLink,
    hasPlayNowLink,
    hasWorldCupQuizLink,
} from "../../utils/quiz";
import Background from "../components/background.component.vue";
import MainMenuButton from "../components/main-menu-button.component.vue";
import { getUid } from "../helpers/auth-helpers.js";
import {
    checkIsDisableQuizzSubDomains,
    config,
    getSubdomain,
} from "../helpers/domain-config.js";
import { replaceText } from "../helpers/domain-text-config.js";
import { getGenericData, transitionTo } from "../utils/aframe.utils";
import { sendPageView } from "../utils/dataCollection.utils";
import { getDomainTheme } from "../utils/domains-theme";

export default {
  components: {
    Background,
    MainMenuButton,
  },
  data: () => ({
    newArrivalsText: "",
    newArrivalsDate: "",
    buttons: {
      type: Object,
      default: {},
    },
    centerImage: {
      type: Object,
      default: {
        title: "",
        content: "",
      },
    },
    selectedLanguage: getSelectedLanguage(),
    isDisableQuizz: checkIsDisableQuizzSubDomains(),
    showContent2: getDomainConfigValue("showContent2"),
    showFootballContent: getDomainConfigValue("showFootballContent"),
    showWorldCupContent: getDomainConfigValue("showWorldCupContent"),
  }),
  methods: {
    hasPlayAndWinLink,
    hasPlayNowLink,
    hasWorldCupQuizLink,
    getPlayAndWinLink,
    getWorldCupQuizLink,
    navigateTo360Category(category) {
      this.navigateTo(`videos/${category}`);
    },
    navigateTo(commands) {
      transitionTo(commands.split("/"));
    },
    replaceText,
    openStrikerLive() {
      const strikerUrl = getDomainConfigValue("strikerLiveUrl");
      if (strikerUrl) {
        window.location.href = strikerUrl;
      }
    },
  },
  computed: {
    playNowLink() {
      if (this.isDisableQuizz) {
        return "";
      }

      const token = getUid();
      const link = getPlayNowLink();
      if (!link || !token) return "";
       return `${link}?uid=${token}`;
    },
    playAndWinLink() {
      if (this.isDisableQuizz) {
        return "";
      } else {
        const token = getUid();
        const subdomain = getSubdomain();

        // window.location.href = `http://localhost:5173/?uid=${userToken}`;
        return `${getPlayAndWinLink()}?uid=${token}&subdomain=${subdomain}`;
      }
    },
    worldCupQuizLink() {
      if (this.isDisableQuizz) {
        return "";
      } else {
        const token = getUid();
        const subdomain = getSubdomain();

        return `${getWorldCupQuizLink()}?uid=${token}&subdomain=${subdomain}`;
      }
    },
    quizLink() {
      if (this.isDisableQuizz) {
        return "";
      } else {
        const token = getUid();
        const subdomain = getSubdomain();

        // window.location.href = `http://localhost:5173/?uid=${userToken}`;
        return `${getQuizLink()}?uid=${token}&subdomain=${subdomain}`;
      }
    },
    backgroundImg() {
      return (
        getDomainTheme(config.productName).mainMenuBgImage ||
        "https://blobs-xr-academy-fxhygyhwcddyerbg.z03.azurefd.net/backgrounds/main-menu.jpg"
      );
    },
  },
  async created() {
    getNewArrivalsDate().then((value) => { this.newArrivalsDate = value; });
    const { homeCenterImage, homeCategories, newArrivalsText } = await getGenericData();
    this.newArrivalsText = newArrivalsText;
    this.buttons = homeCategories;
    this.centerImage = homeCenterImage;
  },
  mounted() {
    sendPageView();
  },
};
</script>

<style scoped lang="scss">
.main-menu {
  .credit-card-content {
    margin-bottom: 14% !important;
  }
  .content {
    margin: 0;
    padding: 20vw 20px;
    font-size: 12px;
    .new-arrivals-button {
      display: block;
      width: 100%;
      max-width: 287px;
      min-height: 44px;
      margin: 0 auto 16px;
      padding: 8px 16px;
      border: 0;
      border-radius: 10px;
      background: url("/images/main-menu/bg-new-arrivals.svg") center / 100% 100% no-repeat;
      color: white;
      font: inherit;
      font-size: 18px;
      cursor: pointer;

      .rotation-date {
        display: block;
        margin-top: 2px;
        font-size: 11px;
        line-height: 1.2;
      }

      &:hover,
      &:focus-visible {
        filter: brightness(1.15);
      }
    }
    .disable-quizz-center-image-bg {
      background-image: url("/images/main-menu/center.png") !important;
    }

    .center-image {
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("/images/main-menu/center2.png");
      background-position: center;
      color: white;
      display: flex;
      flex-direction: column;
      min-height: 500;
      .text {
        flex-grow: 0;
        padding: 20px 30px 10px 30px;
        color: #fff;

        .small {
          font-size: 12px;
        }

        .medium {
          font-size: 14px;
          font-weight: bold;
        }

        .large {
          font-size: 24px;
          font-weight: bold;
        }
      }
      .center-image-middle {
        position: relative;
        height: 300px;
        .animation-group {
          left: 20;
          right: 0;
          display: block;
          position: absolute;
          img {
            position: absolute;
            height: 300;
          }
        }
        .animated {
          animation-duration: 1s;
          animation-fill-mode: both;

          &.infinite {
            animation-iteration-count: infinite;
          }
        }
        .zoomIn {
          animation-name: zoomIn;
        }
      }
      .right-align {
        text-align: right;
      }
      .start-btn-container {
        display: block;
        #start-btn {
          flex-grow: 0;
          color: #fff;
          width: 287px;
          height: 46px;
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 10px;
          display: flex;
          cursor: pointer;
          position: relative;
          align-items: center;
          text-decoration: none;
          justify-content: space-between;
          background-image: url(/images/main-menu/start_btn_bg.png);
          .btn-text {
            font-size: 20px;
            padding-left: 20px;
          }
          .animation-group {
            top: 8px;
            left: 205px;
            position: absolute;
            right: 0;
            margin: auto;
            display: block;
            img {
              position: absolute;
            }
            .arrow-mover {
              animation: 1s arrow_mover steps(2) infinite;
            }
          }
        }
        .disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }

      .fadeInUp {
        animation-name: fadeInUp;
      }
    }
    .header-component {
      width: 100%;
      padding-bottom: 10px;
    }
    .hide-for-fr {
      display: none;
    }
    .chatbot-container {
      margin-left: 100vw;
      z-index: 25;
      &.visible {
        margin-left: 0;
      }
    }
  }

  .delay-0 {
    animation-delay: 0s;
  }
  .delay-1 {
    animation-delay: 0.25s;
  }
  .delay-2 {
    animation-delay: 0.5s;
  }
  .delay-3 {
    animation-delay: 0.75s;
  }
  .delay-4 {
    animation-delay: 1s;
  }
  .delay-5 {
    animation-delay: 1.25s;
  }
  .delay7s {
    animation-delay: 7s;
  }
  .delay7_25s {
    animation-delay: 7.25s;
  }
  .delay8s {
    animation-delay: 8s;
  }
  .header {
    width: 100%;
  }
  .football-content-button {
    background: url("/images/main-menu/bg-football.png") no-repeat center;
    background-size: cover;
    height: 160px;
    width: 100%;
  }
  .football-content-button p {
    text-align: center;
    transform: translateY(105px);
    color: white;
    font-size: 32px;
  }
  .worldcup-content-button {
    background: url("/images/main-menu/worldcup-btn.png") no-repeat center;
    background-size: cover;
    height: 160px;
    width: 100%;
  }
  .worldcup-content-button p {
    text-align: center;
    transform: translateY(105px);
    color: white;
    font-size: 32px;
  }
  @media screen and (min-width: 500px) {
    .content {
      .center-image {
        height: 85%;
      }
    }
  }
  @media screen and (max-width: 385px) {
    .content {
      .center-image {
        height: 540px;
      }
    }
  }
  @media screen and (max-width: 320px) {
    .content {
      .center-image {
        height: 400px;
        .text {
          h1 {
            &:nth-child(2) {
              font-size: 28px;
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: 420px) and (orientation: landscape) {
    .content {
      display: flex;
      position: relative;
      padding: calc(9vw + 52px) 12px 9vw;

      .new-arrivals-button {
        position: absolute;
        top: 9vw;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 40px);
        max-width: 287px;
        font-size: 16px;
      }
      .disable-quizz-center-image-bg {
        min-height: unset !important;
      }

      .header {
        width: 30%;
        order: 2;
        margin: 1%;
      }
      .center-image {
        order: 2;
        margin: 6px 9px;
        height: unset;
        width: 46%;
        .text {
          h1 {
            &:nth-child(1) {
              font-size: 15px;
            }
            &:nth-child(2) {
              font-size: 26px;
            }
          }
        }
      }
      .menuButton_conatiner1 {
        display: flex;
        flex-direction: column;
        width: 56%;
        order: 3;
      }
      .menuButton_container2 {
        display: flex;
        flex-direction: column;
        width: 56%;
      }
      .menu-button-left {
        order: 3 !important;
      }
      .menu-button-right {
        order: 1 !important;
      }
    }
  }
  @media screen and (max-width: 668px) and (orientation: landscape) {
    .content {
      .center-image {
        //height: 261px;
        //width: 48%;
        .text {
          h1 {
            &:nth-child(1) {
              font-size: 13px;
            }
            &:nth-child(2) {
              font-size: 21px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 480px) and (orientation: landscape) {
    .content {
      .center-image {
        height: 216px;
        .text {
          h1 {
            &:nth-child(2) {
              font-size: 19px;
            }
          }
        }
      }
    }
  }
  @keyframes arrow_mover {
    0% {
      opacity: 0;
      transform: translateX(-30px);
    }

    50% {
      opacity: 1;
      transform: translateX(30px);
    }

    100% {
      opacity: 1;
      transform: translateX(30px);
    }
  }
  @keyframes zoomIn {
    from {
      opacity: 0;

      transform: scale3d(0.3, 0.3, 0.3);
    }

    50% {
      opacity: 1;
    }
  }
  @keyframes fadeInUp {
    from {
      opacity: 0;

      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;

      transform: translate3d(0, 0, 0);
    }
  }
}
</style>
